import React from "react";
import PrivacyPolicyHero from "../components/PrivacyPolicy/privacyPolicy.component";
import NavBar from "../components/NavBar/navBar.component";
import Footer from "../components/Footer/footer.component";

function PrivacyPolicy() {
  return (
    <div>
      <NavBar />
      <PrivacyPolicyHero />
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
